module.exports = {
	"0C00000A91": [
		1,
		0,
		0,
		1,
		0,
		1,
		0
	],
	"0C000009CY": [
		5,
		0,
		0,
		1,
		1,
		2,
		1
	],
	"0C00000Q5S": [
		-1,
		0,
		0,
		-1,
		-1,
		-1,
		-1
	],
	"0C00000AJ5": [
		4,
		0,
		0,
		1,
		1,
		2,
		0
	],
	"0C000006SQ": [
		2,
		0,
		0,
		1,
		0,
		2,
		0
	],
	"0C000006WA": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C0000097M": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000007J5": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000UK9": [
		4,
		0,
		0,
		1,
		0,
		2,
		1
	],
	"0C00000WSQ": [
		2,
		0,
		0,
		2,
		0,
		2,
		0
	],
	"0C00000FXY": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00009T8Q": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000Q8G": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000M5E": [
		1,
		0,
		0,
		1,
		0,
		1,
		0
	],
	"0C00003BIC": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000008Y6": [
		3,
		0,
		0,
		1,
		1,
		1,
		1
	],
	"0C00004I9U": [
		1,
		0,
		0,
		1,
		0,
		1,
		0
	],
	"0C00008RH6": [
		4,
		0,
		1,
		2,
		1,
		1,
		1
	],
	"0C00000B7P": [
		0,
		0,
		0,
		0,
		0,
		1,
		0
	],
	"0C000008F4": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000CCL": [
		0,
		0,
		0,
		0,
		0,
		1,
		0
	],
	"0C000009KN": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000HA5": [
		1,
		0,
		0,
		1,
		0,
		1,
		0
	],
	"0C0000343O": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000AHZ": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000006U3": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C00000OHG": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000Q7P": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000006U9": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C000006UP": [
		1,
		0,
		0,
		1,
		1,
		0,
		0
	],
	"0C00000D28": [
		4,
		1,
		0,
		2,
		2,
		2,
		0
	],
	"0C000017TW": [
		2,
		0,
		0,
		1,
		1,
		1,
		0
	],
	"0C00000Q8I": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000U0A": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00006EPP": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000P3P": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000P5M": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000749": [
		0,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C000007DF": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C00000ENX": [
		6,
		1,
		0,
		2,
		2,
		2,
		2
	],
	"0C00000LHD": [
		0,
		0,
		0,
		1,
		0,
		1,
		0
	],
	"0C00000VYG": [
		4,
		0,
		0,
		2,
		1,
		2,
		0
	],
	"0C00000ASH": [
		2,
		0,
		0,
		2,
		0,
		0,
		0
	],
	"0C00000ETI": [
		6,
		1,
		0,
		2,
		2,
		2,
		2
	],
	"0C00000AXM": [
		2,
		0,
		0,
		2,
		1,
		2,
		0
	],
	"0C00000BC7": [
		1,
		0,
		0,
		1,
		0,
		2,
		0
	],
	"0C00000OHJ": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000Q8J": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000BGZ": [
		4,
		0,
		0,
		1,
		1,
		2,
		1
	],
	"0C00000QEK": [
		3,
		0,
		1,
		2,
		2,
		2,
		0
	],
	"0C00000BMT": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C000007ZR": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C0000084T": [
		4,
		1,
		0,
		1,
		1,
		2,
		1
	],
	"0C00000L3L": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000008HA": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C000008JD": [
		4,
		0,
		0,
		1,
		1,
		1,
		1
	],
	"0C00000GI5": [
		1,
		1,
		0,
		1,
		2,
		2,
		1
	],
	"0C00000WLH": [
		4,
		1,
		3,
		1,
		2,
		2,
		0
	],
	"0C0000564A": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000CA5": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C00001QMP": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C000008UN": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C00000OT1": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000DUQ": [
		3,
		1,
		0,
		1,
		2,
		2,
		0
	],
	"0C00000Q6A": [
		1,
		0,
		0,
		1,
		0,
		2,
		0
	],
	"0C00000MSR": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000Y96": [
		0,
		0,
		0,
		0,
		0,
		0,
		0
	],
	"0C00000COO": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C00000CSM": [
		1,
		0,
		0,
		1,
		0,
		2,
		1
	],
	"0C00000Q8L": [
		5,
		1,
		0,
		2,
		2,
		2,
		2
	],
	"0C000009MU": [
		1,
		0,
		0,
		1,
		0,
		0,
		0
	],
	"0C000009NT": [
		1,
		0,
		0,
		1,
		0,
		1,
		0
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/OilGasPolicyTracker.json
// module id = 1010
// module chunks = 0